import AuthService from "../services/auth.service";

export const login = (username, password, clientid, errorCallback) => (dispatch) => {
    return AuthService.login(username, password, clientid, errorCallback).then((x) => {
        if (x) {
            window.location = "/";
        }
    });
};

export const refresh = async () => {
    return await AuthService.refresh();
};


export const logout = () => (dispatch) => {
  dispatch({
    type: "LOGOUT",
  });
};
